import { CopilotControlAuditPanelContextDefinition } from 'components/Copilot/ControlAudit/copilotControlAuditPanelContextDefinition';
import { CopilotPanelContext } from 'models/copilot/copilotBridge';

export class CopilotControlDocumentationAuditPanelContextDefinition extends CopilotControlAuditPanelContextDefinition {
  constructor() {
    super();
    this.context = CopilotPanelContext.ControlDocumentationAudit;
    this.name = 'ControlDocumentationAudit';
  }
}
